import React, { useState, useEffect } from 'react';
import { Widget, GridView, SimpleView } from '@digital/ui';
import { ReportCapexManeger, getReportCapexManeger } from '../../../api/relatorios';
import CapexManagementSumary from '@app/views/Graficos/capexManagementSumary';
import CapexManagement from '@app/views/Graficos/capexManagement';
import CapexManagementGrafico from '@app/views/Graficos/capexManagementGrafico';

const ExecutiveSummary = () => {
  const [relatorio, setRelatorio] = useState<ReportCapexManeger>();

  useEffect(() => {
    getReportCapexManeger().then((data) => {
      if (data) {
        setRelatorio(data);
      }
    });
  }, [])

  return (
    <SimpleView>
      <GridView noform>
        {relatorio ? <CapexManagementSumary data={relatorio} /> : <></>}
        {relatorio ? <CapexManagementGrafico data={relatorio} /> : <></>}
        {relatorio ? <CapexManagement data={relatorio} /> : <></>}
      </GridView>
    </SimpleView>
  );
};

export default ExecutiveSummary;
